package com.wintermar.inspection.feature.presentation.inspection.answer

import com.wintermar.inspection.feature.domain.model.inspection.InspectionModel
import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateModel

sealed class InspectionAnswerEvent {
    data class NavigateToLanding(val inspectionModel: InspectionModel) : InspectionAnswerEvent()
    data class NavigateToSearchQuestion(val inspectionTemplate: InspectionTemplateModel) :
        InspectionAnswerEvent()
}
